<template>
    <div class="dashboard_classification">
        <div class="main_div">
            <div class=" headerTop">
                <div class="header_section_header">
                    <div class="left_aligned_title">
                        <div class="header_title">Clasificación de Documentos</div>
                        <div class="header_description">
                            Consulta, clasifica y organiza toda la información financiera de tu
                            negocio.
                        </div>
                    </div>
                    <div class="right_aligned_buttons ml-2">
                        <div class="button_tipo_contraparte">
                            <div style="min-width: 180px">
                                <SelectComponent v-model="selectedTypeLocal" label="Tipo Contraparte" :weirdOptions="null"
                                    :options="typeOptions" />
                            </div>
                        </div>
                        <div class="button_tipo_contraparte">
                            <div style="min-width: 230px">
                                <SelectComponent v-model="selectedRangeLocal" currentIcon="calendar" label="Rango de tiempo"
                                    :options="periodDataSelect" :weirdOptions="null" />
                            </div>
                        </div>
                        <div v-if="localTypeFiles.length > 0" class="button_tipo_contraparte is-justify-content-end">
                            <div style="min-width: 230px">
                                <SelectComponent v-model="selectedUploadFile" :staticLabel="'Subir Documentos'"
                                    theme="classification_theme" :weirdOptions="null" currentIcon="UploadFile"
                                    :options="localTypeFiles" />
                            </div>
                        </div>
                        <div :class="['is-align-content-end', 'is-clickable', {'is-disabled-local': getUrlDriveClassification=='' || isDownloadingFile}]">
                            <span class="btnNoClassify is-flex is-justify-content-center is-clickable mr-2"
                                :class="{
                                    'theme_dark_btn': isDownloadingFile, 
                                    'theme_default_btn': !isDownloadingFile}" 
                                @click="()=>downloadFile(getUrlDriveClassification, 'Data clasificada.xlsx')">
                                <DownloadFile class="ecs" />
                                <!-- Bajar documentos -->
                            </span>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="counterpart_table_header">
                        <div class="search_container">
                            <SearchIcon class="search_icon" />
                            <input type="text" class="search_input " v-model="searchFilter"
                                placeholder="Buscar por nombre o rut" />
                            <button v-if="searchFilter" class="clear_button" @click="searchFilter = ''">
                                <Ecs class="ecs" />
                            </button>
                        </div>
                        <div style="width: 200px;" class="mr-3">
                            <b-checkbox :class="{
                                    'theme_dark_btn': filterTable != '', 
                                    'theme_default_btn': filterTable == ''}" 
                                class="btnNoClassify is-full-width" true-value="Sin Clasificar" :false-value="''"
                                :key="filterTable" v-model="filterTable">
                                <span class="pl-0">Sin Clasificar</span>
                            </b-checkbox>
                        </div>
                        <div style="width: 200px;" class="mr-3">
                            <b-checkbox :class="{
                                    'theme_dark_btn': filterTableHasAccrual != '', 
                                    'theme_default_btn': filterTableHasAccrual == ''}" 
                                    class="btnNoClassify is-full-width" true-value="Devengados" :false-value="''"
                                :key="filterTableHasAccrual" v-model="filterTableHasAccrual">
                                <span class="pl-0">
                                    Devengados
                                    <CalendarMinus class="ecsFilter" :class="{'iconWhite': filterTableHasAccrual != ''}"/>
                                </span>
                            </b-checkbox>
                        </div>
                        <div style="width: 200px;" class="mr-3" v-if="allFilterCategories.length >0">
                            <SelectComponent ref="SelectCategoryComponent" :staticLabel="'Categorizados'" :hasSearchBox="true"
                                theme="classification_theme" :isSearchable="true" :weirdOptions="allFilterCategories"
                                iconRight="DashboardSquare"
                                @selectedValues="e => updateSelectedCategories(e)" :isAccount="true" />
                        </div>
                        <div style="width: 200px;">
                            <SelectComponent ref="SelectAccountComponent" :staticLabel="'Clasificados'" :hasSearchBox="true"
                                iconRight="RobotFace"
                                theme="classification_theme" :isSearchable="true" :weirdOptions="allAccountsOnDocs"
                                @selectedValues="e => updateSelectedAccounts(e)" :isAccount="true" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="underHeader">


                <div class="container_table_main_table main_table mb-5">
                    <table class="big_table">
                        <colgroup v-if="categories.length == 2">
                            <col style="width: 20%" />
                            <!--nombre-->
                            <col style="width: 10%" />
                            <!--clasificación-->
                            <col style="width: 10%" />
                            <!--monto-->
                            <col style="width: 10%" />
                            <!--contraparte-->
                            <col style="width: 10%" />
                            <!--cuenta madre-->
                            <col style="width: 10%" />
                            <!--cuenta-->
                            <col style="width: 10%" />
                            <!--categoría 1-->
                            <col style="width: 10%" />
                            <!--categoría 2-->
                            <col style="width: 2%" />
                            <!--editar-->
                        </colgroup>
                        <colgroup v-if="categories.length == 1">
                            <col style="width: 20%" />
                            <!--nombre-->
                            <col style="width: 10%" />
                            <!--clasificación-->
                            <col style="width: 10%" />
                            <!--monto-->
                            <col style="width: 10%" />
                            <!--contraparte-->
                            <col style="width: 15%" />
                            <!--cuenta madre-->
                            <col style="width: 15%" />
                            <!--cuenta-->
                            <col style="width: 15%" />
                            <!--categoría 1-->
                            <col style="width: 2%" />
                            <!--editar-->
                        </colgroup>
                        <colgroup v-if="categories.length == 0">
                            <col style="width: 30%" />
                            <!--nombre-->
                            <col style="width: 10%" />
                            <!--clasificación-->
                            <col style="width: 10%" />
                            <!--monto-->
                            <col style="width: 10%" />
                            <!--contraparte-->
                            <col style="width: 15%" />
                            <!--cuenta madre-->
                            <col style="width: 20%" />
                            <!--cuenta-->
                            <col style="width: 5%" />
                            <!--editar-->
                        </colgroup>
                        <tr v-if="this.accountFilters.length > 0"
                            :class="['fix-position', { 'first': this.accountFilters.length > 0 }]">
                            <!-- <tr v-if="this.accountFilters.length > 0"> -->
                            <td colspan="9">
                                <div class="header_filters pl-5">
                                    <span v-for="(accountFilter, iAccountFilter) in accountFilters"
                                        v-bind:key="iAccountFilter">
                                        <span class="itemFilter mr-3"
                                            @click="() => deleteItemFilter('accounts', accountFilter)"
                                            v-if="accountFilter && iAccountFilter < 4">
                                            {{ accountFilter }}
                                            <Ecs class="ecsFilter" />
                                        </span>
                                    </span>
                                    <span v-if="accountFilters.length > 4" class="itemFilter">
                                        +{{ accountFilters.length - 4 }}
                                    </span>
                                    <div class="is-pulled-right mr-4">
                                        <button class="itemFilter" @click="() => clearFiltered('accounts')">
                                            Limpiar Filtro
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="this.categoriesFilter.length > 0"
                            :class="['fix-position', {
                                'second': this.categoriesFilter.length >0 && this.accountFilters.length > 0,
                                'first': this.categoriesFilter.length > 0 && this.accountFilters.length == 0
                            }]">
                            <td colspan="9">
                                <div class="header_filters pl-5">
                                    <span v-for="(categoryFilter, iCategoryFilter) in categoriesFilter"
                                        v-bind:key="iCategoryFilter">
                                        <span class="itemFilter mr-3"
                                            @click="() => deleteItemFilter('category', categoryFilter)"
                                            v-if="categoryFilter && iCategoryFilter < 4">
                                            {{ categoryFilter }}
                                            <Ecs class="ecsFilter" />
                                        </span>
                                    </span>
                                    <span v-if="categoriesFilter.length > 4" class="itemFilter">
                                        +{{ categoriesFilter.length - 4 }}
                                    </span>
                                    <div class="is-pulled-right mr-4">
                                        <button class="itemFilter" @click="() => clearFiltered('category')">
                                            Limpiar Filtro
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr
                            :class="['fix-position', {
                                'third': this.accountFilters.length > 0 && this.categoriesFilter.length > 0,
                                'second': this.accountFilters.length > 0 || this.categoriesFilter.length > 0,
                                 'first': this.accountFilters.length == 0 && this.categoriesFilter.length == 0
                            }]">
                            <!-- <tr> -->
                            <td class="ttitle">
                                <div class="tttitle t_razon_social">
                                    Nombre
                                    <SortButton @click="changeOrderGeneric('alias')" class="ml-1"
                                        :globalSortColumn="sortColumn" :column="'alias'" :sortDirection="sortDirection">
                                    </SortButton>
                                </div>
                            </td>
                            <td class="t_clasificacion ttitle">
                                <div class="tttitle td_clasificacion">
                                    Clasificación
                                    <SortButton @click="changeOrderGeneric('classify_by_counterpart')"
                                        :globalSortColumn="sortColumn" :column="'classify_by_counterpart'"
                                        :sortDirection="sortDirection"></SortButton>
                                </div>
                            </td>
                            <td class="t_monto ttitle">
                                <div class="tttitle">
                                    <span class="nobreak">$ Monto</span>
                                    <SortButton @click="changeOrderGeneric('total_3_months')"
                                        :globalSortColumn="sortColumn" :column="'total_3_months'"
                                        :sortDirection="sortDirection"></SortButton>
                                </div>
                            </td>
                            <td class="t_contraparte ttitle">
                                <div class="tttitle">
                                    Contraparte
                                    <SortButton @click="changeOrderGeneric('counterpart_type')"
                                        :globalSortColumn="sortColumn" :column="'counterpart_type'"
                                        :sortDirection="sortDirection"></SortButton>
                                </div>
                            </td>
                            <td class="t_cuenta_madre ttitle">
                                <div class="tttitle">
                                    Cuenta Madre
                                    <SortButton @click="changeOrderGeneric('mother_accounts')"
                                        :globalSortColumn="sortColumn" :column="'mother_accounts'"
                                        :sortDirection="sortDirection"></SortButton>
                                </div>
                            </td>
                            <td class="t_cuenta ttitle">
                                <div class="tttitle">
                                    Cuenta
                                    <SortButton @click="changeOrderGeneric('accounts')" :globalSortColumn="sortColumn"
                                        :column="'accounts'" :sortDirection="sortDirection">
                                    </SortButton>
                                </div>
                            </td>
                            <td class="t_categoria ttitle" v-for="type in categories" v-bind:key="type">
                                <div class="tttitle is-capitalized">
                                    {{ type }}
                                    <SortButton @click="changeOrderGeneric('attribute', type)"
                                        :globalSortColumn="sortColumn" :column="'attribute_' + type"
                                        :sortDirection="sortDirection" />
                                </div>
                            </td>
                            <td>
                                <!-- pencil -->
                            </td>
                        </tr>
                        <tr v-for="entry in getPaginatedList" v-bind:key="entry.ci_id + ' ' + entry.counterpart_type"
                            class="counterpart_row">
                            <td class="fila">
                                <div class="alias is-clickable zhigh" @click="() =>
                                    openAccountByCompanyModal(
                                        entry
                                    )
                                ">
                                    <div class="c_alias">{{ entry.alias }}</div>
                                    <div v-if="entry.counterpart_type != 'Recibo'" class="c_rut">
                                        {{ entry.rut }}
                                    </div>
                                </div>
                            </td>
                            <td class="fila">
                                <div class="docs_totals_bar td_clasificacion">
                                    <div class="nobreak_classify_desc">
                                        <div :class="[
                                            'pill',
                                            'pill_' +
                                            entry.classify_by_counterpart
                                                .toLowerCase()
                                                .replace(' ', '_'),
                                        ]">
                                            {{ entry.classify_by_counterpart }}
                                        </div>
                                    </div>
                                    <div class="count_button">
                                        <div class="chart_container">
                                            <table class="subtable">
                                                <tr>
                                                    <td class="progress_td">
                                                        <progress :class="getProgressBarClass(entry)"
                                                            :value="getProgressValue(entry)"
                                                            :max="getProgressMax(entry)" />
                                                    </td>
                                                    <td class="progress_td">
                                                        <div class="docs_totals nobreak">
                                                            {{ entry.classified }} /
                                                            {{ entry.tax_document_count }}
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="fila">
                                <div class="has-text-left">{{ money(entry.total_3_months) }}</div>
                            </td>
                            <td class="fila">
                                <div :class="[
                                    'pill',
                                    'pill_' +
                                    entry.counterpart_type.toLowerCase().replace(' ', '_'),
                                    'counterpart_type',
                                    { charge: entry.pay_or_charge == 'C' },
                                ]">
                                    {{ entry.counterpart_type }}
                                </div>
                            </td>
                            <td class="fila">
                                <div class="square_pill pill_sin_clasificar nobreak"
                                    v-if="!entry.calculatedAccounts || !entry.calculatedAccounts.length">
                                    Sin Clasificar
                                </div>
                                <div class="square_pill pill_mother_account grey_pill nobreak"
                                    v-for="(account, index) in entry.calculatedMotherAccounts" v-bind:key="index">
                                    {{ account }}
                                </div>
                            </td>
                            <td class="fila is-capitalized">
                                <!-- <div v-if="entry.accounts">
                                    <span class="square_pill pill_mother_account grey_pill nobreak"
                                        v-for="plan in entry.accounts" v-bind:key="plan['level_3'] + entry.id">
                                        {{ plan["level_3"] }}
                                    </span>
                                </div> -->
                                <div v-if="entry.doc_accounts">
                                    <span class="square_pill pill_mother_account grey_pill nobreak"
                                        v-for="plan in entry.calculatedAccounts" v-bind:key="plan + entry.ci_id">
                                        {{ plan }}
                                    </span>
                                </div>
                                <div v-if="(!entry.accounts || !entry.accounts.length) && entry.doc_accounts.length == 0"
                                    class="square_pill pill_clasificar is-clickable" @click="() =>
                                        openAccountByCompanyModal(
                                            entry
                                        )
                                    ">
                                    <EditPencil class="edit_pencil" />
                                    Clasificar
                                </div>
                            </td>
                            <td class="fila is-capitalized" v-for="type in categories"
                                v-bind:key="entry.ci_id + '_' + type">
                                <div v-if="type in entry.calculatedCategories">
                                    <div v-for="subtype in entry.calculatedCategories[type]"
                                        v-bind:key="subtype+'_'+ entry.ci_id"
                                        class="pill pill_mother_account blue_pill nobreak">
                                        {{ subtype }}
                                    </div>
                                </div>
                                <div class="pill pill_sin_clasificar nobreak" v-else>
                                    Sin Clasificar
                                </div>
                            </td>
                            <td class="fila is-clickable has-text-centered" @click="() =>
                                openAccountByCompanyModal(
                                    entry
                                )
                            ">
                                <EditPencil class="edit_pencil" />
                            </td>
                        </tr>
                    </table>
                </div>
                <Pagination v-model="actualPage" :maxPages="maxPages" />
            </div>
        <ResumeClassificationModal
            :active.sync="showFirstTimeModal"
            :typeOptions="typeOptions"
            :periodDataSelect="periodDataSelect"
            @reloadCounterpart="getAllPaginatedCounterparts"
        />
        </div>
    </div>
</template>

<script>
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/900.css";

import Ecs from "@/components/svg/Ecs.vue";
import EditPencil from "@/components/svg/EditPencil.vue";
import SearchIcon from "@/components/svg/SearchIcon.vue";
import CalendarMinus from "@/components/svg/CalendarMinus.vue";
import DownloadFile from "@/components/svg/DownloadFile.vue";

import SelectComponent from "@/components/classification/SelectComponent";
import Pagination from "@/components/generics/Pagination";
import ClassifyAccountAttributes from "@/components/modals/ClassifyAccountAttributes";
import ModalFullHeightRight from "@/components/modals/ModalFullHeightRight";
import BodyUploadDocs from "@/components/uploadDocuments/modalParts/bodyUploadDocs";
import HeaderUploadDocs from "@/components/uploadDocuments/modalParts/headerUploadDocs";
import ResumeClassificationModal from "@/components/modals/ResumeClassificationModal";
import { parseToMoney } from "@/utils/currency";
import SortButton from "../components/modals/SortButton.vue";
import { getUrlsDownloadFile } from "@/api/uploadFiles";
import { exportClassificationsToSheet } from "@/api/downloadObligationsToSheet";
import { mapActions, mapState } from "vuex";
import { notificate } from "../utils/message";

let countDirectionOrder = 0;

export default {
    name: "DashboardClassificator",
    components: {
        SortButton,
        SelectComponent,
        EditPencil,
        SearchIcon,
        Ecs,
        CalendarMinus,
        Pagination,
        DownloadFile,
        ResumeClassificationModal
    },
    data() {
        return {
            showFirstTimeModal: false,
            hasShownFirstTimeModal: false,
            maxWord: 20,
            barWidth: 300,
            barHeight: 20,
            labelWidth: 50,
            chartWidth: 250,
            show_counterpart_filter: false,
            publicPath: "http://" + window.location.hostname,
            show_period_chooser: false,
            showXDocumento: false,
            switch1: false,
            sortColumn: "order",
            sortDirection: "asc",
            currentPeriod: 60,
            modalDefault: {
                parent: this,
                width: "99%",
                hasModalCard: true,
                canCancel: ["escape", "outside"],
                customClass: "center-always-modal",
            },
            searchFilter: "",
            localTypeFiles: [],
            selectedUploadFile: "",
            filterTable: "",
            filterTableHasAccrual: '',
            actualPage: 1,
            itemsPerPage: 20,
            allAccountsOnDocs: [],
            allFilterCategories: [],
            accountFilters: [],
            categoriesFilter: [],
            isDownloadingFile: false
        };
    },
    props: {
    },
    mounted() {

        this.initClassificationFilters();
        this.localTypeFiles = this.typeFiles.filter(typeFile =>{
            return this.user.valid_counterparts.length == 0 || this.user.valid_counterparts.includes(typeFile.counterpartType)
        })       
        this.getAllAccounts().then(() => {
            this.selectedRangeLocal = 'last12' // here load all docs on watch
        })

        this.changeColumn("total_3_months");
        this.sortData("total_3_months")
        this.changeColumn("total_3_months");
        this.sortData("total_3_months")

    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutsidePeriod);
        document.removeEventListener("click", this.handleClickOutsideFilter);
    },
    methods: {
        ...mapActions("classification", ["setPeriodDataSelect", "getCategories",
            "getAllAccounts", "getAllCounterparts", "setSelectedPeriodCounterparts",
            "updateCounterpart", "setOrderedCounterparts", "orderCounterparts",
            "updateSelectedType", "updateDataCharts", "initClassificationFilters"]),
        ...mapActions("uploadFiles", ["setNewSelectedTypeFile"]),
        getProgressBarClass(entry) {
            return entry.classified === entry.tax_document_count
                ? "progress_bar_full"
                : entry.classified === 0 ? "progress_bar_empty" : "progress_bar";
        },
        getProgressValue(entry) {
            if (entry.classified === entry.tax_document_count) {
                return entry.classified;
            }
            const classified = 100 * entry.classified;
            return classified + (6 * classified) / (classified + 1.01);
        },
        getProgressMax(entry) {
            return entry.classified === entry.tax_document_count
                ? entry.tax_document_count
                : 100 * entry.tax_document_count;
        },
        downloadFile(drive_id, file_name) {
            this.isDownloadingFile = true
            if (!drive_id) return;
            
            notificate(
                `<strong>Procesando!</strong><br>
                Generando archivo de clasificaciones...`,
                "is-info is-light"
            );

            exportClassificationsToSheet({'rut_company': this.user?.companies?.[0]?.rut || ''})
                .then(() => {
                    notificate(
                        `<strong>Éxito!</strong><br>
                        Archivo generado. Obteniendo enlace de descarga...`,
                        "is-success is-light"
                    );
                    return getUrlsDownloadFile({ drive_id, file_name });
                })
                .then(({ data }) => {
                    notificate(
                        `<strong>Éxito!</strong><br>
                        Descarga iniciada.`,
                        "is-success is-light"
                    );
                    let url = data.url_download
                    url = url.match(/^https?:/) ? url : '//' + url;
                    window.open(url)
                })
                .catch((error) => {
                    notificate(
                        `<strong>Error!</strong><br>
                        Ocurrió un error en la descarga del archivo.`,
                        "is-danger is-light"
                    );
                    console.error("Error downloading file:", error);
                })
                .finally(() => {
                    this.isDownloadingFile = false
                })
        },
        updateSelectedAccounts(accountsSelected) {
            if (accountsSelected.length != 0) {
                this.filterTable = ''
            }
            this.accountFilters = [...accountsSelected]
            this.allFiltersToEntries()
        },
        updateSelectedCategories(categoriesSelected) {
            if (categoriesSelected.length != 0) {
                this.filterTable = ''
            }
            this.categoriesFilter = [...categoriesSelected]
            this.allFiltersToEntries()
        },
        clearFiltered(type) {
            if(type=='accounts'){
                this.$refs.SelectAccountComponent.clearCbList()
            } else {
                this.$refs.SelectCategoryComponent.clearCbList()
            }
            
            this.allFiltersToEntries()
        },
        deleteItemFilter(type, item) {
            if(type == 'accounts'){
                this.$refs.SelectAccountComponent.deleteItemCbList(item)
            } else {
                this.$refs.SelectCategoryComponent.deleteItemCbList(item)
            }
        },

        toggleCounterpartFilter() {
            this.show_counterpart_filter = !this.show_counterpart_filter;
            if (this.show_counterpart_filter) {
                setTimeout(
                    () =>
                        document.addEventListener("click", this.handleClickOutsideFilter),
                    1
                );
            } else {
                document.removeEventListener("click", this.handleClickOutsideFilter);
            }
        },
        togglePeriodChooser() {
            this.show_period_chooser = !this.show_period_chooser;
            if (this.show_period_chooser) {
                setTimeout(
                    () =>
                        document.addEventListener("click", this.handleClickOutsidePeriod),
                    1
                );
            } else {
                document.removeEventListener("click", this.handleClickOutsidePeriod);
            }
        },
        handleClickOutsidePeriod(event) {
            const periodChooser = this.$refs.periodChooser;
            if (periodChooser && !periodChooser.$el.contains(event.target)) {
                this.show_period_chooser = false;
                document.removeEventListener("click", this.handleClickOutsidePeriod);
            }
        },
        handleClickOutsideFilter(event) {
            const filterChooser = this.$refs.filterChooser;
            if (filterChooser && !filterChooser.$el.contains(event.target)) {
                this.show_counterpart_filter = false;
                document.removeEventListener("click", this.handleClickOutsideFilter);
            }
        },
        closeTimeFrameChooser() {
            this.show_period_chooser = false;
        },
        handleClose() {
            this.show_period_chooser = false;
            this.show_counterpart_filter = false;
            document.removeEventListener("click", this.handleClickOutsidePeriod);
            document.removeEventListener("click", this.handleClickOutsideFilter);
        },
        resetMsgs() {
            this.sortColumn = "total_3_months";
            this.sortDirection = "desc";
        },
        findLowestLevel1(list, isMotherAccount = false) {
            const orderPlanMap = { "Ventas": 0, "Costos": 1, "Gastos": 2, "No Operacional": 3, "Activos": 4 };
            let min = 99999;
            for (const elem of list) {
                const val = isMotherAccount ? elem : elem["level_1"];
                const io = orderPlanMap[val] !== undefined ? orderPlanMap[val] : -1;
                if (io >= 0 && io < min) {
                    min = io;
                }
                if (min === 0) {
                    break;
                }
            }
            return min;
        },
        sortData(column, subtype = null, reset_msg = true) {
            if (reset_msg) {
                this.resetMsgs();
            }
            let col_name = column;
            if (subtype != null) {
                col_name = "attribute_" + subtype;
            }
            if (countDirectionOrder == 0) {
                this.sortColumn = "order";
                this.sortDirection = "asc";
            } else if (countDirectionOrder == 1) {
                this.sortColumn = col_name;
                this.sortDirection = "asc";
            } else if (countDirectionOrder == 2) {
                this.sortColumn = col_name;
                this.sortDirection = "desc";
            }
        },
        changeColumn(column, subtype = null) {
            let column_name = column;
            if (subtype) {
                column_name = column + "_" + subtype;
            }
            if (this.sortColumn != column_name) {
                countDirectionOrder = 0;
                this.sortColumn = column;
                if (subtype) {
                    this.sortColumn = column + "_" + subtype;
                }
            }
            countDirectionOrder = (countDirectionOrder + 1) % 3;
        },
        sortEntriesFunc(a, b, subtype) {
            let pos = this.sortColumn.indexOf("attribute_");
            let col_name = this.sortColumn;
            if (pos == 0) {
                col_name = "attribute";
            }
            const valA = a[col_name];
            const valB = b[col_name];
            if (col_name == "accounts") {
                const la = valA.length;
                const lb = valB.length;
                if (la == 0 || lb == 0) {
                    return this.sortDirection === "asc" ? la - lb : lb - la;
                }
                const lowestA = this.findLowestLevel1(valA);
                const lowestB = this.findLowestLevel1(valB);
                if (lowestA == lowestB) {
                    const subOrderA = valA[0].level_3;
                    const subOrderB = valB[0].level_3;
                    const diff = subOrderA.localeCompare(subOrderB);
                    return this.sortDirection === "asc" ? diff : -diff;
                }
                return this.sortDirection === "asc"
                    ? lowestA - lowestB
                    : lowestB - lowestA;
            } else if (col_name == "mother_accounts") {
                const la = valA.length;
                const lb = valB.length;
                if (la == 0 || lb == 0) {
                    return this.sortDirection === "asc" ? la - lb : lb - la;
                }
                const lowestA = this.findLowestLevel1(valA, true);
                const lowestB = this.findLowestLevel1(valB, true);
                if (lowestA == lowestB) {
                    const subOrderA = a["total_3_months"];
                    const subOrderB = b["total_3_months"];
                    return subOrderB - subOrderA;
                }
                return this.sortDirection === "asc"
                    ? lowestA - lowestB
                    : lowestB - lowestA;
            } else if (col_name == "attribute") {
                if (!valA[subtype] && !valB[subtype]) {
                    const subOrderA = a["total_3_months"];
                    const subOrderB = b["total_3_months"];
                    return subOrderB - subOrderA;
                } else if (valA[subtype] && !valB[subtype]) {
                    return 1
                } else if (!valA[subtype] && valB[subtype]) {
                    return -1
                }
                let totalA = valA[subtype][0]["name"],
                    totalB = valB[subtype][0]["name"];
                if (totalA == totalB) {
                    const subOrderA = a["total_3_months"];
                    const subOrderB = b["total_3_months"];
                    return subOrderB - subOrderA;
                }
                const total_diff = totalA.localeCompare(totalB);
                return this.sortDirection === "asc" ? total_diff : -total_diff;
            } else {
                let compare = 0;
                if (
                    (typeof valA === "boolean" && typeof valB === "boolean") ||
                    (typeof valA === "number" && typeof valB === "number")
                ) {
                    compare = valA - valB;
                } else {
                    compare = valA.localeCompare(valB);
                }
                if (compare == 0) {
                    const subOrderA = a["total_3_months"];
                    const subOrderB = b["total_3_months"];
                    return subOrderB - subOrderA;
                }
                return this.sortDirection === "asc" ? compare : -compare;
            }
        },
        actualSort(subtype = null) {
            let classifiedEntries = [];
            let notClassifiedEntries = [];
            
            for (const oEntry of this.allOrderedCounterparts) {
                if ((oEntry.accounts && oEntry.accounts.length > 0) || (oEntry.classify_by_counterpart != 'Sin Clasificar')) {
                    classifiedEntries.push(oEntry);
                } else {
                    notClassifiedEntries.push(oEntry);
                }
            }

            classifiedEntries.sort((a, b) => this.sortEntriesFunc(a, b, subtype));
            notClassifiedEntries.sort((a, b) => this.sortEntriesFunc(a, b, subtype));

            const newOrderedEntries = [...notClassifiedEntries, ...classifiedEntries]
            this.setOrderedCounterparts(newOrderedEntries)
        },
        changeOrderGeneric(column, subtype = null) {
            this.changeColumn(column, subtype);
            this.sortData(column, subtype, false);
            this.actualSort(subtype);
        },
        money(value) {
            if (value != "") {
                return parseToMoney(value);
            }
        },
        na_warning() {
            notificate(
                "No se puede asignar esta categoría sin asignar una Cuenta de Venta o de Costo primero."
            );
        },
        async getAllPaginatedCounterparts() {
            let request = {
                from: 0,
                to: 999999,
                from_day: this.selectedPeriodCounterparts.from,
                to_day: this.selectedPeriodCounterparts.to,
            };
            await this.getAllCounterparts(request)
            this.actualSort(null);
            this.updateDataCharts();
            this.allFiltersToEntries()
            const allOrdered = JSON.parse(JSON.stringify(this.allOrderedCounterparts))
            this.orderCounterparts(allOrdered)
            
            if (!this.hasShownFirstTimeModal) {
                this.hasShownFirstTimeModal = true;
                this.showFirstTimeModal = true;
            }
        },
        openAccountByCompanyModal(contraparte) {
            try {
                this.$buefy.modal.open({
                    ...this.modalDefault,
                    component: ClassifyAccountAttributes,
                    customClass: "classify_modal_width",
                    props: {
                        rangeOptions: this.periodDataSelect,
                        rangeFromMainScreen: this.selectedRange,
                        types: this.categories,
                        counterpart: contraparte,
                    },
                    events: {
                        reloadCounterpart: () => {
                            setTimeout(() => {
                                this.updateDataCharts()
                                this.actualSort(null);
                                this.allFiltersToEntries()
                            }, 200);
                        },
                    },
                });
            } catch (err) {
                console.log("error?:", err);
            }
        },
        allFiltersToEntries() {
            const isAccountFiltersEmpty = this.accountFilters.length === 0;
            const isCategoriesFilterEmpty = this.categoriesFilter.length === 0;

            const normalizeStr = (str) => str ? str.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase() : "";
            const rawFilter = this.searchFilter ? this.searchFilter.trim() : "";
            const filterSearchText = rawFilter ? normalizeStr(rawFilter) : "";

            const newOrderedEntries = this.allOrderedCounterparts.map(entry => {
                entry.isClassifying = false;

                let matchesSearch = true;
                if (filterSearchText) {
                    if (!entry.allTextNormalized) {
                        entry.allTextNormalized = normalizeStr(entry.allText);
                    }
                    matchesSearch = entry.allTextNormalized.indexOf(filterSearchText) >= 0;
                }

                entry.visible = (
                    this.selectedType === "todos" ||
                    this.selectedType === entry.counterpart_type
                ) && matchesSearch &&
                (
                    (
                        this.filterTable == 'Sin Clasificar' &&
                        entry.accounts.length == 0 &&
                        entry.classified != entry.tax_document_count
                    ) || (
                        this.filterTable == '' && (
                            isAccountFiltersEmpty ||
                            entry.accounts.some(
                                account => this.accountFilters.includes(account.level_3)
                            ) ||
                            entry.doc_accounts.some(
                                account => this.accountFilters.includes(account)
                            )
                        ))
                ) && (
                    (
                        this.filterTableHasAccrual == 'Devengados' &&
                        entry.has_accrual
                    ) || this.filterTableHasAccrual == ''
                ) && (
                    (
                        this.filterTable == '' && (
                            isCategoriesFilterEmpty ||
                            (entry.calculatedCategories && Object.keys(entry.calculatedCategories).some(key =>
                                entry.calculatedCategories[key].some(
                                    item => this.categoriesFilter.includes(item)
                            )))
                        ) ||
                        this.filterTable == 'Sin Clasificar'
                    ) 
                )
                return entry
            })
            this.setOrderedCounterparts(newOrderedEntries)
            let usedAccountsSet = new Set();
            let usedCategories = {}
            newOrderedEntries.forEach(entry => {
                if (!entry.visible) {
                    return
                }
                if (entry.accounts && entry.accounts.length > 0) {
                    entry.accounts.forEach(account => usedAccountsSet.add(account.level_3));
                }
                if (entry.doc_accounts && entry.doc_accounts.length > 0) {
                    entry.doc_accounts.forEach(account => usedAccountsSet.add(account));
                }
                if (entry.calculatedCategories){
                    this.categories.forEach(cat =>{
                        if(!entry.calculatedCategories[cat]){
                            return
                        }
                        if(!usedCategories[cat]){
                            usedCategories[cat] = new Set()
                        }
                        entry.calculatedCategories[cat].forEach(usedCat =>{
                            usedCategories[cat].add(usedCat)
                        })
                    })
                }
            })
            
            let filterCategories = []
            Object.keys(usedCategories).forEach(key=>{
                usedCategories[key].forEach(cat=>{
                    filterCategories.push( {
                        value: cat,
                        level_3: cat,
                        level_2: key
                    })
                })
            })
            this.allFilterCategories = filterCategories
            const allUniqueAccounts = [...usedAccountsSet]
            this.allAccountsOnDocs = this.allAccounts.filter(account => allUniqueAccounts.includes(account.level_3))

            if (this.getPaginatedList.length == 0) {
                this.actualPage = 1
            }
        },

    },
    computed: {
        ...mapState("classification", ["periodDataSelect", "selectedPeriodCounterparts", "categories",
            "allAccounts", "allCounterparts", "allOrderedCounterparts", "selectedType",
            "selectedCounterpartObject", "dataCounterparts", "dataDocuments", "dataExpenses", "selectedRange", "typeOptions"]),
        ...mapState("uploadFiles", ["typeFiles"]),
        ...mapState("userAuth", ["user"]),
        filteredListCounterparts: function () {
            return this.allOrderedCounterparts.filter(entry => entry.visible)
        },
        maxPages: function () {
            return Math.ceil(this.filteredListCounterparts.length / this.itemsPerPage) || 1;
        },
        getPaginatedList: function () {
            const startIndex = (this.actualPage - 1) * this.itemsPerPage
            const endIndex = this.actualPage * this.itemsPerPage
            return this.filteredListCounterparts.slice(startIndex, endIndex)
        },
        getUrlDriveClassification: function(){
            return this.user?.companies?.[0]?.settings?.url_drive_file_reporting_classification || ""
        },
        selectedRangeLocal: {
            get() { return this.selectedRange },
            set(newValue) {
                const optionSelected = this.periodDataSelect.find(
                    (o) => o.value == newValue
                );
                this.setSelectedPeriodCounterparts(optionSelected)
                this.getAllPaginatedCounterparts();
            }
        },
        selectedTypeLocal: {
            get() { return this.selectedType },
            set(newValue) {
                const optionSelected = this.typeOptions.find((o) => o.value == newValue);
                this.updateSelectedType(optionSelected);
                this.allFiltersToEntries()
            }
        }
    },
    watch: {
        searchFilter() {
            this.allFiltersToEntries()
        },
        filterTable(newFilter) {
            if (newFilter) {
                this.$refs.SelectAccountComponent.clearCbList()
                this.$refs.SelectCategoryComponent.clearCbList()
            }
            this.allFiltersToEntries()
        },
        filterTableHasAccrual(){
            this.allFiltersToEntries()
        },
        selectedUploadFile(newSelected) {
            if (newSelected != '') {
                this.setNewSelectedTypeFile(newSelected)
                this.$buefy.modal.open({
                    ...this.modalDefault,
                    component: ModalFullHeightRight,
                    customClass: "classify_modal_width",
                    props: {
                        headerComp: HeaderUploadDocs,
                        bodyComp: BodyUploadDocs,
                        headerProps: {
                        },
                        bodyProps: {
                        },
                    },
                    events: {
                        closeModalFn: () => {
                            this.selectedUploadFile = ''
                            this.getAllPaginatedCounterparts()
                        }
                    },
                });
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.ecsFilter {
    height: 20px;
    overflow: hidden;
    flex-shrink: 0;
    margin-bottom: -5px;
}

.headerTop {
    position: sticky;
    top: 110px;
    width: 100%;
    background-color: white;
    z-index: 5;
}

.underHeader {
    position: relative;
}


.main_div {
    padding-left: clamp(10px, 5.5vw, 90px);
    padding-right: clamp(10px, 5.5vw, 93px);
    padding-bottom: 30px;
}

.dashboard_classification {
    border-top: 1px solid #eaecf0;
    background-color: #fcfcfd;
    font-family: Inter, "Open Sans", sans-serif;
}

.header_section_header {
    padding-top: 30px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.left_aligned_title {
    flex: 1;
}

.right_aligned_buttons {
    display: flex;
    flex-direction: row;
    gap: 20px;
    margin-bottom: 1.5rem;
}

.button_tipo_contraparte {
    display: flex;
    flex-direction: column;
    align-items: left;
}

.header_title {
    font-size: 1.5em;
    font-weight: bold;
    margin-bottom: 5px;
}

.header_description {
    font-size: 1em;
    color: gray;
}

.ttitle {
    text-align: center;
    vertical-align: middle;
    padding: 10px 0 10px 0;
}

.td_clasificacion {
    max-width: 100px !important;
}



.tttitle {
    font-weight: 500;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #fcfcfd;
    box-sizing: border-box;
    text-align: left;
    font-size: 12px;
    color: #475467;
    font-family: Inter;
}

.t_razon_social {
    margin-left: 7px;
}

.template_attribute {
    font-weight: normal;
}

.counterpart_row {
    border-top: 1px solid #eaecf0;
    margin-bottom: 10px;
}

.alias {
    margin: 16px 8px;
    text-align: left;
}



.fila {
    background-color: #ffffff;
    vertical-align: middle;
}

.charge {
    color: #ff0000;
}

.c_alias {
    line-height: 20px;
    text-transform: uppercase;
    font-weight: 400;
    line-height: 20px;
    color: #101828;
}

.c_rut {
    font-size: 80%;
    font-weight: 500;
    line-height: 20px;
    color: #465467;
}

.container_table_main_table {
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #eaecf0;
    overflow-y: auto;
    max-height: 70vh;
    scrollbar-width: none;
}

.main_table {
    border-collapse: collapse;
}



.nobreak_classify_desc {
    text-align: left;
    white-space: nowrap;
    font-size: 80%;
}



.count_button {
    text-align: center;
}







.header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
}

.header-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100px;
}

.filter_button {
    vertical-align: top;
    margin-left: 6px;
}

.period_button {
    width: 70px !important;
    vertical-align: top;
    margin-left: 6px;
}

.order_button {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    padding: 0;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: all 0.3s ease;
}

.fade-slide-enter,
.fade-slide-leave-to {
    opacity: 0;
    transform: translateY(-30px);
}

.counterpart_table_header {
    background-color: #eaecf0;
    height: 60px;
    width: 100%;
    padding: 12px 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
}

.header_filters {
    background-color: #eaecf0;
    height: 30px;
}

.itemFilter {
    padding: 2px 4px 2px 8px;
    align-items: center;
    gap: 2px;
    border-radius: 6px;
    border: 1px solid var(--Gray-300, #D0D5DD);
    background: var(--Base-White, #FFF);

    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

    color: var(--Gray-700, #344054);
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    cursor: pointer;
}

.search_container {
    display: flex;
    align-items: center;
    flex: 1;
    padding: 0 10px;
}

.search_icon {
    position: relative;
    top: 0;
    left: -5px;
    z-index: 2;
}

.search_input {
    width: clamp(100px, 25vw, 300px);
    position: relative;
    left: -30px;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    border-radius: 8px;
    background-color: #fff;
    border: 1px solid #d0d5dd;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 8px 8px 8px 27px;
    text-align: left;
    font-size: 14px;
    color: #667085;
    font-family: Inter;
    z-index: 1;
    padding-right: 30px;
}

.search_input:focus {
    outline: none;
    border: 1px solid #d0d5dd;
    box-shadow: 0 0 4px #abadb2;
}

.clear_button {
    position: relative;
    left: -60px;
    top: 16px;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    font-size: 16px;
    cursor: pointer;
    color: #888;
    z-index: 2;
}

.filter_container {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 0;
    flex: 2;
}

$select_transition: 0.1s;

.select_button {
    text-align: center;
    border-radius: 0;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    border-right: 0.5px solid #ccc;
    border-left: 0.5px solid #ccc;
    margin: 0;
    padding: clamp(5px, 6px, 8px) clamp(10px, 12px, 16px);
    background-color: #ffffff;
    color: #000000;
    transition: all $select_transition ease;
}

.select_button:first-of-type {
    border-left: 1px solid #ccc;
}

.select_button:last-of-type {
    border-right: 1px solid #ccc;
}

.select_button:hover {
    background-color: #c7c7c7;
    color: #000000;
    transition: all $select_transition ease;
}

.black_button {
    background-color: #002e33 !important;
    color: #ffffff !important;
    transition: all $select_transition ease;
}

.black_button:hover {
    background-color: #185555 !important;
    color: #ffffff !important;
    transition: all $select_transition ease;
}

@media (max-width: 800px) {
    .search_input {
        width: 100%;
    }

    .counterpart_table_header {
        flex-direction: column;
        align-items: stretch;
        height: 120px;
    }

    .filter_container {
        justify-content: center;
        flex-wrap: wrap;
        width: 100%;
        margin-top: 10px;
    }

    .filter_container .select_button {
        flex: 1 1 auto;
        min-width: 100px;
        text-align: center;
    }

    .select_button {
        padding: clamp(0px, 1px, 3px) clamp(0px, 5px, 10px);
    }
}

@media (max-width: 550px) {
    .counterpart_table_header {
        flex-direction: column;
        align-items: stretch;
        height: 210px;
    }
}

.big_table {
    width: 100%;
    table-layout: fixed;
    max-width: 100%;
    border-radius: 8px;
}

.fix-position {
    position: sticky;
    z-index: 1;
    background-color: white;
}

.first {
    top: 0px;
}

.second {
    top: 30px;
}

.third {
    top: 60px;
}

.table_responsive {
    overflow-x: auto;
}

.chart_container {
    display: flex;
    align-items: center;
}

.pill_sin_clasificar {
    color: #344054;
    background-color: #f9fafb;
    border: 1px solid #eaecf0;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.pill_contraparte {
    color: #175cd3;
    background-color: #eff8ff;
    border: 1px solid #b2ddff;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.pill_documento {
    color: #067647;
    background-color: #ecfdf3;
    border: 1px solid #abefc6;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.pill_mixta {
    color: #5925dc;
    background-color: #f4f3ff;
    border: 1px solid #d9d6fe;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.blue_pill {
    background-color: #f4f3ff;
    border: 1px solid #d9d6fe;
}

.grey_pill {
    background-color: #eaecf0;
    border: 1px solid #d0d5dd;
}

.pill_mother_account {
    line-break: auto;
    display: block;
    color: #475467;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.square_pill {
    position: relative;
    border-radius: 4px;
    box-sizing: border-box;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0px 2px 1px 2px;
    text-align: center;
    font-size: 12px;
    font-family: Inter, "Open Sans", sans-serif;
    width: min-content;
    min-width: 4em;
}

.pill {
    position: relative;
    border-radius: 16px;
    box-sizing: border-box;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0px 8px 1px 8px;
    text-align: center;
    font-size: 12px;
    font-family: Inter, "Open Sans", sans-serif;
    width: min-content;
    overflow-wrap: break-word;
    word-wrap: break-word;
    min-width: 4em;
}

.edit_pencil {
    margin-right: 2px;
}

.pill_clasificar {
    position: relative;
    box-shadow: 0px 1px 8px rgba(16, 24, 40, 0.05);
    border-radius: 8px;
    background-color: #fef3f2;
    border: 1px solid #fecdca;
    box-sizing: border-box;
    width: 103px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 8px 12px;
    gap: 4px;
    text-align: left;
    font-size: 12px;
    color: #b42318;
    font-family: Inter;
    font-weight: 600;
}

.pill_proveedor {
    color: #b93815;
    background-color: #fef6ee;
    border: 1px solid #f9dbaf;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.pill_proveedor::before {
    content: "💼";
    margin-right: 3px;
}

.pill_cliente {
    color: #067647;
    background-color: #ecfdf3;
    border: 1px solid #abefc6;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.pill_cliente::before {
    content: "🤝";
    margin-right: 3px;
}

.pill_trabajador {
    color: #5925dc;
    background-color: #f4f3ff;
    border: 1px solid #d9d6fe;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.pill_trabajador::before {
    content: "‍‍🧑‍💻";
    margin-right: 3px;
}

.pill_honorario {
    color: #344054;
    background-color: #f9fafb;
    border: 1px solid #eaecf0;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.pill_honorario::before {
    content: "‍🕒";
    margin-right: 3px;
}

.pill_internacional {
    color: #175cd3;
    background-color: #eff8ff;
    border: 1px solid #b2ddff;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.pill_internacional::before {
    content: "🌍";
    margin-right: 3px;
}

.pill_finiquito {
    color: #344054;
    background-color: #f9fafb;
    border: 1px solid #eaecf0;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.pill_finiquito::before {
    content: "📄";
    margin-right: 3px;
}

.pill_recibo {
    color: #c11574;
    background-color: #fdf2fa;
    border: 1px solid #fcceee;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.pill_recibo::before {
    content: "🧾";
    margin-right: 3px;
}

progress {
    appearance: none;
}

$progress_background: #d0d5dd;
$progress_bar_normal: #00a9be;
$progress_bar_full: #00a9be;
$progress_bar_empty: #f63c3c;

.progress_bar {
    background-color: $progress_background;
    border-radius: 13px;
    border: 0;
    height: 10px;
    width: 50px;
}

.progress_bar::-webkit-progress-bar {
    background-color: $progress_background;
    border-radius: 13px;
}

.progress_bar::-webkit-progress-value {
    background-color: $progress_bar_normal;
    border-top-left-radius: 13px;
    border-bottom-left-radius: 13px;
}

.progress_bar::-moz-progress-bar {
    background-color: $progress_bar_normal;
}

.progress_bar_empty {
    background-color: $progress_bar_empty;
    border-radius: 13px;
    border: 0;
    height: 10px;
    width: 50px;
}

.progress_bar_full {
    background-color: $progress_background;
    border-radius: 13px;
    border: 0;
    height: 10px;
    width: 50px;
}


.progress_bar_full::-webkit-progress-bar {
    background-color: $progress_background;
    border-radius: 13px;
}

.progress_bar_full::-webkit-progress-value {
    background-color: $progress_bar_full;
    border-radius: 13px;
}

.progress_bar_full::-moz-progress-bar {
    background-color: $progress_bar_full;
}

.progress_td {
    vertical-align: middle;
    width: 50%;
}

.docs_totals {
    position: relative;
    top: 3px;
    margin-left: 20px;
    font-size: 10px;
    line-height: 20px;
    font-weight: 500;
    font-family: Inter;
    color: #344054;
    text-align: left;
}

.docs_totals_bar {
    padding: 5px 0 0 0;
    width: 100px;
}

.t_clasificacion {
    padding: 10px 0 10px 0;
}

.t_contraparte {
    padding: 10px 0 10px;
}

.theme_dark_btn{
    --background-color: #002e33;
    --background-hover: #185555;
    --text-color: #fff;
}

.theme_default_btn{
    --background-color: #FFF;
    --background-hover: #185555;
    --text-color: #333a48;
}

.btnNoClassify {
    padding: 10px 14px;
    align-items: center;
    gap: 8px;
    color: var(--Gray-900, #101828);
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;

    border-radius: 8px;
    border: 1px solid var(--Gray-300, #D0D5DD);
    background: var(--background-color, #FFF);
    color: var(--text-color, #000);

    /* Shadows/shadow-xs */
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    height: 46px;
}

.btnNoClassify:hover{
    background: var(--background-hover);
    color: #fff;
    .ecsFilter, .ecs{
        filter: brightness(0) invert(1);
    }
}

.iconWhite {
    filter: brightness(0) invert(1);
}

.zhigh {
    z-index: 3000;
}
</style>
<style>
.classify_modal_width .modal-background {
    background-color: rgba(0, 0, 0, 0.45) !important;
}

.classify_modal_width {
    min-width: 870px;
}


</style>
